import { Button, Link } from "@shopify/polaris"
import { useEffect, useRef } from "react"
import { Trans, useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useIntercom } from "react-use-intercom"

import MigrateSetupGuideTabContent from "../components/MigrateSetupGuideTabContent"
import { MigrateSetupGuideTabProps } from "./types"

const SyncOrdersTab = ({ onCompleteStep, isCompleted }: MigrateSetupGuideTabProps) => {
  const { t } = useTranslation(["dashboard", "common"])
  const navigate = useNavigate()
  const { showNewMessage } = useIntercom()
  const hasRequestedCompleteRef = useRef(false)

  const handleViewOrders = async () => {
    navigate("/orders")
  }

  useEffect(() => {
    if (isCompleted || !onCompleteStep || hasRequestedCompleteRef.current) {
      return
    }

    hasRequestedCompleteRef.current = true
    void onCompleteStep(0)
  }, [isCompleted, onCompleteStep])

  return <MigrateSetupGuideTabContent
    header={t("dashboard:SyncRecentOrders")}
    description={t("dashboard:SyncRecentOrdersDescription")}
    media={<img src={"https://cdn.parcelpanel.com/front-end/2026/tms-migration/sync-orders.svg"} alt={""} />}
    actions={
      <Button
        variant={isCompleted ? "secondary" : "primary"}
        onClick={handleViewOrders}
      >
        {t("dashboard:ViewOrders")}
      </Button>
    }
    footer={<Trans ns={"dashboard"} i18nKey={"NeedHelp"}>
      <Link onClick={() => showNewMessage("")} removeUnderline />
    </Trans>}
  />
}

export default SyncOrdersTab
